<template>
  <div class="create-order">
    <div class="headLine">
      <img src="./leftAngle.png" alt="返回首页" @click="backIndex" />
      化验设备检定
    </div>
    <div class="form-wrapper">
      <el-form
        label-width="100px"
        label-position="right"
        :rules="rules"
        ref="form"
        :model="formLabelAlign"
      >
        <el-form-item label="设备名称:" prop="deviceName">
          <el-input v-model="formLabelAlign.deviceName" placeholder="请输入设备名" disabled />
        </el-form-item>
        <el-form-item label="检定时间:" prop="time">
          <el-date-picker
            v-model="formLabelAlign.time"
            type="date"
            placeholder="检定时间"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="备注:" prop="remark" style="margin-top: 20px;">
          <el-input v-model="formLabelAlign.remark"
                    type="textarea"
                    rows="6"
                    maxlength="500"
                    placeholder="备注，500字以内" />
        </el-form-item>
        <div class="form-submit">
          <el-button class="btn"
                     :disabled="btnDisabled"
                     :loading="submitTag !== 'normal'"
                     @click.prevent="createOrder">
            <span v-if="submitTag === 'normal'">创建检定记录</span>
            <span v-else>创建中</span>
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { debounce } from '@/utils/common'
import moment from "moment";
export default {
  data () {
    return {
      id: 0,
      formLabelAlign: {
        deviceName: '', // 设备名
        time: "", // 检定时间
        deviceId: '', // 设备id
        remark: "", // 备注
      },
      rules: {
        name: [
          { required: true, message: '请输入设备名', trigger: 'blur' }
        ],
        time: [
          { required: true, message: '请输入检定日期', trigger: 'blur' }
        ],
      },
      submitTag: 'normal',
      btnDisabled: false,
      permission: false
    }
  },
  created () {
    this.$nextTick(() => {
      this.getAssetsType()
    })
  },
  methods: {
    // 返回首页
    backIndex() {
      this.$router.replace({
        name: 'deviceVerification',
        query: {
          id: this.id,
          permission: this.permission,
        }
      })
    },
    // 获取设备资产类型
    getAssetsType () {
      this.permission = this.$route.query.permission;
      // 固定资产还要通过code拿数据
      this.formLabelAlign.deviceId = this.$route.query.id;
      this.formLabelAlign.deviceName = this.$route.query.name;
      this.formLabelAlign.time = moment(new Date()).format("YYYY-MM-DD")
      this.btnDisabled = false
      this.submitTag = 'normal'
    },
    // 创建保养或者校正单记录
    createOrder: debounce(function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.submitTag === 'normal') {
            this.submitTag = 'creating'
            // 先检查是否有其他这个参数
            this.$http.httpPost('/app/laDeviceVerification/save', {
              "time": this.formLabelAlign.time,
              "deviceId": this.formLabelAlign.deviceId,
              "deviceName": this.formLabelAlign.deviceName,
              "remark": this.formLabelAlign.remark,
            }).then(res => {
              if (res.code === 0 && res.msg === 'success') {
                this.$message({
                  message: '创建成功',
                  type: 'success'
                });

                this.formLabelAlign = {
                  "deviceId": '',
                  "deviceName": '',
                  "time": '',
                  "remark": '',
                }
                this.submitTag = 'normal'
                this.back()
              } else {
                this.$message({
                  message: `创建失败，错误信息:${res.msg}`,
                  type: 'error'
                });
                this.submitTag = 'normal'
              }
              this.submitTag = 'normal'
              this.btnDisabled = true
            })
          } else {
            this.submitTag = 'normal'
          }
        } else {
          // 校验没通过
          this.$message({
            message: '校验不通过',
            type: 'error'
          });
          this.submitTag = 'normal'
        }
      })
    }),
    // 回到工单列表页面
    back () {
      setTimeout(() => {
        this.$router.replace({
          name: 'deviceVerification',
          query: {
            permission: this.permission,
          }
        })
      }, 1000);
    },
  }
}
</script>

<style lang="scss">
.create-order {
  width: 100%;
  padding: 50px 0 0;
  background: #fff;
  .headLine {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    background-color: #fff;
    height: 50px;
    color: #000;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    font-size: 16px;
    z-index: 99;
    border-bottom: 1px #efefef solid;
    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .form-wrapper {
    .el-form {
      padding: 15px 15px;
      .el-form-item__label {
        // font-weight: 700;
        font-size: 14px;
        color: #000;
      }
      .el-form-item {
        margin-bottom: 10px;
        .el-date-editor {
          width: 100%;
        }
        .fixed {
          position: relative;
          .fixed-device-name {
            border: none;
            outline: none;
            font-size: 1.6rem;
            background-color: inherit;
            cursor: not-allowed;
          }
          input:disabled {
            color: #333;
            opacity: 0.8;
            -webkit-text-fill-color: #333;
          }
          .fixed-btn {
            position: absolute;
            right: 0;
            top: 0;
            width: 8rem;
            height: 3rem;
            font-size: 1.2rem;
            color: #fff;
            background: #409eff;
          }
        }

      }
      .filterCheckBox {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        .el-form-item__label {
          width: 100% !important;
          text-align: left;
          padding: 0 0 0 28px;
          flex: 0 0 100%;
        }
        .el-form-item__content {
          margin-left: 0 !important;
          flex: 0 0 100%;
          .insideRadio {
            position: relative;
            display: flex;
            flex-wrap: wrap;
            .el-checkbox {
              flex: 0 0 50%;
              margin-right: 0;
            }
            .longLabel {
              flex: 0 0 100%;
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              justify-content: center;
              .el-checkbox__label {
                flex: 1;
                .el-textarea {
                  width: 100%;
                }
              }
            }
          }
        }

      }
      .form-submit {
        text-align: center;
        width: 100%;
        z-index: 99;
        border-top: 1px #efefef solid;
        border-bottom: 1px #efefef solid;
        button {
          width: 80%;
          height: 4rem;
          margin: 10px 0;
          background-color: #67c23a;
          font-size: 1.6rem;
          font-weight: bold;
          &:hover,
          &:active {
            color: #fff;
          }
        }
        .tips {
          font-size: 1.4rem;
          color: #ccc;
          // margin-top: 1rem;
          padding-bottom: 0.5rem;
        }
      }
    }
  }
}
.el-radio.is-disabled {
  border-color: #e4e7ed;
  color: #333;
  opacity: 0.8;
  -webkit-text-fill-color: #333;
  cursor: not-allowed;
}
</style>
